export interface TopicItem {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  reason: string;
  image: string;
  mediaIds: string[];
}

export const topicList: TopicItem[] = [
  {
    id: "topic1",
    title: "华语科幻新浪潮",
    subtitle: "当想象力的边界被一次次推开",
    description:
      "从深空探测到星际迁徙，从远古秘境到未来都市，一批华语科幻作品正用扎实的设定与东方的想象，构建属于我们自己的科幻宇宙。本专题精选近年最值得一看的科幻影视作品，带你一次性感受华语科幻的想象力与野心。",
    reason:
      "这些作品不再满足于对国外科幻的模仿，而是尝试把东方的哲学思考、人文关怀与硬核设定结合起来。无论你是资深科幻迷，还是刚刚入坑的新观众，都能在这里找到让你眼前一亮的那一部。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20topic%20banner%20key%20art%2C%20a%20vast%20orange%20nebula%20and%20a%20distant%20futuristic%20city%20on%20a%20planet%20horizon%2C%20epic%20science%20fiction%20wonder%2C%20rich%20warm%20orange%20and%20deep%20blue%20tones%2C%20high%20detail%20digital%20painting%2C%20no%20text%20no%20letters&width=1200&height=700&seq=po18-topic-1&orientation=landscape",
    mediaIds: ["m1", "m8", "m6", "m4", "m10", "m12"],
  },
  {
    id: "topic2",
    title: "年度高分剧集精选",
    subtitle: "值得熬夜追完的口碑佳作",
    description:
      "好剧难得，好剧扎堆更难得。本专题为你梳理近年来口碑与热度兼具的高分剧集，涵盖悬疑、历史、都市、武侠等多种类型。无论你偏爱烧脑推理，还是沉迷古装权谋，都能在这里找到下一部要追的剧。",
    reason:
      "我们综合了评分、讨论热度与观众口碑，从海量剧集中筛选出真正经得起推敲的作品。它们或许题材各异，但都有一个共同点：用扎实的剧本与真诚的表演，尊重每一位观众的注意力。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20topic%20banner%20key%20art%2C%20a%20cozy%20dark%20living%20room%20with%20a%20glowing%20screen%20and%20warm%20lamp%20light%20at%20night%2C%20inviting%20binge%20watching%20mood%2C%20warm%20orange%20and%20amber%20tones%2C%20high%20detail%20illustration%2C%20no%20text%20no%20letters&width=1200&height=700&seq=po18-topic-2&orientation=landscape",
    mediaIds: ["t10", "t4", "t2", "t8", "t7", "t11"],
  },
  {
    id: "topic3",
    title: "治愈系综艺合集",
    subtitle: "把下饭时光交给快乐",
    description:
      "生活已经足够疲惫，不如把下饭时间交给快乐。本专题精选音乐、旅行、美食、生活类综艺，用轻松治愈的内容，为你的每一天补充一点松弛感和好心情。",
    reason:
      "这些节目或许没有激烈的竞技，却有着最真实的烟火气与人情味。无论是独自用餐，还是与家人朋友共处，一档好的综艺总能让平凡的时光变得温暖而有滋味。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20topic%20banner%20key%20art%2C%20a%20warm%20cozy%20picnic%20scene%20outdoors%20with%20friends%2C%20soft%20golden%20afternoon%20light%2C%20relaxing%20joyful%20mood%2C%20warm%20orange%20and%20cream%20tones%2C%20high%20detail%20illustration%2C%20no%20text%20no%20letters&width=1200&height=700&seq=po18-topic-3&orientation=landscape",
    mediaIds: ["v1", "v3", "v8", "v2", "v10", "v11"],
  },
];